<template>
  <div class="border-t border-border p-4 space-y-2">
    <!-- View Cart Button -->
    <button v-if="!cartStore.isEmpty"
            :disabled="cartStore.isLoading"
            class="w-full btn-outline rounded-lg px-4 py-2 font-semibold transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            @click="handleViewCart">
      <i class="fas fa-folder-open mr-2"></i>
      View Cart
    </button>

    <!-- Proceed to Checkout Button -->
    <button v-if="!cartStore.isEmpty"
            :disabled="cartStore.isLoading"
            class="w-full btn-primary rounded-lg px-4 py-2 font-semibold transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            @click="handleProceedToCheckout">
      <i class="fas fa-arrow-right mr-2"></i>
      Proceed to Checkout
    </button>

    <!-- Clear Cart Button -->
    <button v-if="!cartStore.isEmpty"
            :disabled="cartStore.isLoading"
            class="w-full px-4 py-2 text-destructive border border-destructive/30 rounded-lg font-semibold hover:bg-destructive/10 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            @click="handleClearCart">
      <i class="fas fa-trash-alt mr-2"></i>
      Clear Cart
    </button>

    <!-- Empty State Message -->
    <p v-else
       class="text-center text-sm text-muted-foreground py-2">
      Start shopping to add items
    </p>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router';
import { useCartStore } from '@/stores/cartStore';
import { useCheckoutStore } from '@/stores/checkoutStore';
import { useToast } from '@/composables/useToast';

const router = useRouter();
const cartStore = useCartStore();
const checkoutStore = useCheckoutStore();
const { success, error } = useToast();

const emit = defineEmits<{
  close: []
}>();

const handleViewCart = () => {
  emit('close');
  router.push({ name: 'Cart' });
};

const handleProceedToCheckout = async () => {
  try {
    // Sync cart items to checkout store
    checkoutStore.setCheckoutSession({
      cartId: cartStore.cartId || undefined,
      cartItems: cartStore.cartItems,
      isValid: true,
    });

    emit('close');
    router.push({ name: 'Checkout' });
  } catch (err) {
    error('Failed to proceed to checkout');
    console.error('Checkout error:', err);
  }
};

const handleClearCart = async () => {
  if (!confirm('Are you sure you want to clear your cart?')) {
    return;
  }

  try {
    await cartStore.clearCart();
    success('Cart cleared');
  } catch (err) {
    error('Failed to clear cart');
    console.error('Clear cart error:', err);
  }
};
</script>
